import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";

import { deleteUser, getUser } from "../auth/Auth";
import { loadClientUsers, loadClients } from "../common/Common";

import ManageAdmins from "./ManageAdmins";
import ManageClients from "./clients/ManageClients";
import FavoriteClients from "./clients/FavoriteClients";
import AdminDashboard from "./AdminDashboard";
import AccountSettings from "./AccountSettings";
import Dashboard from "./Dashboard";
import FavoriteDashboard from "./FavoriteDashboard";

import logo from "../assets/images/white-logo.svg";
import home from "../assets/images/home.svg";
import activeHome from "../assets/images/active-home.svg";
import favorites from "../assets/images/favorites.svg";
import activeFavorites from "../assets/images/active-favorites.svg";
import profile from "../assets/images/profile.svg";
import activeProfile from "../assets/images/active-profile.svg";
import settings from "../assets/images/settings.svg";
import activeSettings from '../assets/images/active-settings.svg';
import avatar from "../assets/images/avatar.png";

import '../assets/css/Home.css';

function Home() {
    const [component, setComponent] = useState("Dashboard"),
        [user, setUser] = useState(null),
        [count, setCount] = useState(1),
        [clients, setClients] = useState([]),
        [selectedClient, setSelectedClient] = useState(null),
        [link] = useState(decodeURI(window.location.href.split('/').at(-1)));

    const navigate = useNavigate();

    useEffect(() => {
        getUser().then((data) => {
            setUser(data);
            if (data.role.role === 'BASIC') {
                let values = {
                    email: data.email,
                    context: {
                        action: 'List Client Users'
                    },
                    endpoint: '/api/client/client-user-list',
                    token: data.token
                };
                loadClientUsers(values).then(data => {
                    setClients(data);
                    if (data.length > 0) {
                        setSelectedClient(data[0]);
                    }
                }).catch(() => null);
            }
        }).catch(() => {
            setUser(null);
        });

        if (link === "favorite-files") {
            setComponent("Favorite Files");
        } else if (["manage-clients", "add-client"].includes(link)) {
            setComponent("Manage Clients");
        } else if (link === "favorite-clients") {
            setComponent("Favorite Clients");
        } else if (link === "manage-admins") {
            setComponent("Manage Admins");
        } else if (link === "account-settings") {
            setComponent("Account Settings");
        } else {
            setComponent("Dashboard");
        }
    }, []);

    const logout = () => {
        deleteUser().then(() => {
            setUser(null);
            window.location.href = '/login';
        });
    };

    const updateCount = () => {
        setCount(count + 1);
    }

    const clientBody = (clients) => {
        let body = [];

        clients
            .filter(client => client.active?.activeStatus?.toLowerCase() === "active")
            .forEach((client, index) => {
                body.push(
                    <li key={index}
                        className={"d-flex dropdown-item user-client-container " + (selectedClient === client ? " selected-user-client-container" : "")}
                        onClick={() => setSelectedClient(client)}>
                        {client.imageUrl ?
                            <img src={client.imageUrl} alt={client.name} className='user-image' />
                            : <img src={avatar} alt="Avatar" className='user-image' />
                        }
                        <div className='ellipsis-text'>{client.name}</div>
                        {selectedClient === client &&
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#FCDC43"
                                className="bi bi-check-lg" viewBox="0 0 16 16">
                                <path
                                    d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z" />
                            </svg>
                        }
                    </li>
                );
            });

        return body;
    };


    if (user) {
        return (
            <div style={{ display: "flex" }}>
                <div className="vertical-nav sidebar offcanvas offcanvas-start" id="verticalNavbar" tabIndex="-1">
                    <p className='logo'>
                        <img src={logo} alt="Logo" />
                        <button type="button" className="btn-close sidebar-close" data-bs-dismiss="offcanvas"
                            aria-label="Close" />
                    </p>
                    <div className="nav flex-column nav-pills" id="v-pills-tab" role="tablist"
                        aria-orientation="vertical">
                        <Link end to={'/'}
                            className={component === 'Dashboard' ? "nav-link active" : "nav-link"}
                            data-bs-dismiss="offcanvas" data-bs-target="#verticalNavbar"
                            onClick={() => {
                                setComponent("Dashboard");
                                navigate("/");
                            }}>
                            <img src={home} alt="Home Icon" className='sidebar-image inactive-image' />
                            <img src={activeHome} alt="Home Icon" className='sidebar-image active-image' />
                            <span className="sidebar-text">Dashboard</span>
                        </Link>
                        {(user.role.role === 'BASIC') &&
                            <Link end to={'/favorite-files'}
                                className={component === 'Favorite Files' ? "nav-link active" : "nav-link"}
                                data-bs-dismiss="offcanvas" data-bs-target="#verticalNavbar"
                                onClick={() => {
                                    setComponent("Favorite Files");
                                    navigate("/favorite-files");
                                }}>
                                <img src={favorites} alt="Favorite Icon" className='sidebar-image inactive-image' />
                                <img src={activeFavorites} alt="Favorite Icon" className='sidebar-image active-image' />
                                <span className="sidebar-text">Favorites</span>
                            </Link>
                        }
                        {(user.role.role === 'ROOT' || user.role.role === 'ADMIN') &&
                            <Link end to={'/manage-clients'}
                                className={component === 'Manage Clients' ? "nav-link active" : "nav-link"}
                                data-bs-dismiss="offcanvas" data-bs-target="#verticalNavbar"
                                onClick={() => {
                                    setComponent("Manage Clients");
                                    navigate("/manage-clients");
                                }}>
                                <img src={profile} alt="Manage Icon" className='sidebar-image inactive-image' />
                                <img src={activeProfile} alt="Manage Icon" className='sidebar-image active-image' />
                                <span className="sidebar-text">Manage Clients</span>
                            </Link>
                        }
                        {(user.role.role === 'ROOT' || user.role.role === 'ADMIN') &&
                            <Link end to={'/favorite-clients'}
                                className={component === 'Favorite Clients' ? "nav-link active" : "nav-link"}
                                data-bs-dismiss="offcanvas" data-bs-target="#verticalNavbar"
                                onClick={() => {
                                    setComponent("Favorite Clients");
                                    navigate("/favorite-clients");
                                }}>
                                <img src={favorites} alt="Favorite Icon" className='sidebar-image inactive-image' />
                                <img src={activeFavorites} alt="Favorite Icon" className='sidebar-image active-image' />
                                <span className="sidebar-text">Favorites</span>
                            </Link>
                        }
                        {user.role.role === 'ROOT' &&
                            <Link end to={'/manage-admins'}
                                className={component === 'Manage Admins' ? "nav-link active" : "nav-link"}
                                data-bs-dismiss="offcanvas" data-bs-target="#verticalNavbar"
                                onClick={() => {
                                    setComponent("Manage Admins");
                                    navigate("/manage-admins");
                                }}>
                                <img src={profile} alt="Manage Icon" className='sidebar-image inactive-image' />
                                <img src={activeProfile} alt="Manage Icon" className='sidebar-image active-image' />
                                <span className="sidebar-text">Manage Admins</span>
                            </Link>
                        }
                        <div className="logout-component">
                            <div className="d-flex user-component">
                                {user.imageUrl ?
                                    <img src={user.imageUrl} alt={user.firstName} className='user-image' />
                                    : <img src={avatar} alt="Avatar" className='user-image' />
                                }
                                <div style={{ width: "65%", display: "flex", flexDirection: "column", color: "white" }}>
                                    <span>{user.firstName} {user.lastName}</span>
                                    {selectedClient && (
                                        <span style={{ fontSize: "12px", opacity: 0.8 }}>{selectedClient.name}</span>
                                    )}
                                </div>

                                {user.role.role === 'BASIC' &&
                                    <div className="dropup">
                                        <button className="borderless-button" type="button" data-bs-toggle="dropdown"
                                            aria-expanded="false">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                fill="white" className="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                                <path
                                                    d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
                                            </svg>
                                        </button>
                                        <ul className="dropdown-menu user-client-dropdown">
                                            {clientBody(clients)}
                                        </ul>
                                    </div>
                                }
                            </div>
                            <div className="d-flex logout-button-component">
                                <a className="nav-link" id="v-pills-logout-tab" data-toggle="pill"
                                    href="#v-pills-logout" role="tab" aria-controls="v-pills-logout"
                                    aria-selected="false" onClick={() => logout()}>
                                    <span className="sidebar-text">Sign out</span>
                                </a>
                                <Link end to={'/account-settings'}
                                    className={component === 'Account Settings' ? "nav-link active" : "nav-link"}
                                    data-bs-dismiss="offcanvas" data-bs-target="#verticalNavbar"
                                    onClick={() => {
                                        setComponent("Account Settings");
                                        navigate("/account-settings");
                                    }}>
                                    <img src={settings} alt="Settings Icon" className='sidebar-image inactive-image' />
                                    <img src={activeSettings} alt="Settings Icon"
                                        className='sidebar-image active-image' />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nav-detail-container">
                    <div className="tab-content portal-tab-container" id="v-pills-tabContent">
                        <div className={component === "Dashboard" ? "tab-pane fade show active" : "tab-pane fade"}
                            id="v-pills-dashboard" role="tabpanel" aria-labelledby="v-pills-dashboard-tab">
                            {user.role.role === 'ROOT' || user.role.role === 'ADMIN' ?
                                <AdminDashboard count={count} />
                                : <Dashboard selectedClient={selectedClient} updateCount={updateCount} count={count} />
                            }
                        </div>
                        {(user.role.role === 'BASIC') &&
                            <div
                                className={component === "Favorite Files" ? "tab-pane fade show active" : "tab-pane fade"}
                                id="v-pills-favorite-files" role="tabpanel"
                                aria-labelledby="v-pills-favorite-files-tab">
                                <FavoriteDashboard selectedClient={selectedClient} updateCount={updateCount} count={count} />
                            </div>
                        }
                        {(user.role.role === 'ROOT' || user.role.role === 'ADMIN') &&
                            <div className={component === "Manage Clients" ? "tab-pane fade show active" : "tab-pane fade"}
                                id="v-pills-manage-clients" role="tabpanel" aria-labelledby="v-pills-manage-clients-tab">
                                <ManageClients count={count} updateCount={updateCount} />
                            </div>
                        }
                        {(user.role.role === 'ROOT' || user.role.role === 'ADMIN') &&
                            <div
                                className={component === "Favorite Clients" ? "tab-pane fade show active" : "tab-pane fade"}
                                id="v-pills-favorite-clients" role="tabpanel"
                                aria-labelledby="v-pills-favorite-clients-tab">
                                <FavoriteClients count={count} updateCount={updateCount} />
                            </div>
                        }
                        {user.role.role === 'ROOT' &&
                            <div className={component === "Manage Admins" ? "tab-pane fade show active" : "tab-pane fade"}
                                id="v-pills-manage-admins" role="tabpanel" aria-labelledby="v-pills-manage-admins-tab">
                                <ManageAdmins />
                            </div>
                        }
                        <div
                            className={component === "Account Settings" ? "tab-pane fade show active" : "tab-pane fade"}
                            id="v-pills-account" role="tabpanel" aria-labelledby="v-pills-account-tab">
                            <AccountSettings selectedClient={selectedClient} />
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return null;
    }
}

export default Home;

